import { CommonModule, JsonPipe } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, RouterOutlet } from '@angular/router';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { Subject } from 'rxjs';
import { CompensatoryOffService } from '../Model/CompensatoryOff/compensatory-off.service';
import { CommonService } from '../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { SessionService } from '../Util/Session/session.service';
import { UtilityService } from '../Model/utility/utility.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import moment from 'moment';
import { AdminCompoffDetailComponent } from '../admin-compoff-detail/admin-compoff-detail.component';
import { AdminCompoffRequestComponent } from '../admin-compoff-request/admin-compoff-request.component';

@Component({
  selector: 'app-admin-compoff-history',
  standalone: true,
  imports: [CommonModule, RouterModule, NgbDatepickerModule, FormsModule, DataTablesModule, NgbDropdownModule, LoaderComponent],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './admin-compoff-history.component.html',
  styleUrl: './admin-compoff-history.component.scss'
})
export class AdminCompoffHistoryComponent {

  @Input() EmployeeId = 0;
  @Input() EmpType = '';
  isDisabled: boolean = false;
  TableDatas = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  user = [] as any;
  Filter = {
    EmpMasterID: null as any,
    FromDate: null as any,
    ToDate: null as any,
    ApprovalStatus: 'ALL',
    IsWithdraw: false
  }
  dtoptions: DataTables.Settings = {};
  constructor(
    private compensatoryoff: CompensatoryOffService,
    protected common: CommonService,
    private toast: ToastService,
    private session: SessionService,
    private utility: UtilityService,
    private dateFromat: CustomDateParserFormatter,
    private tooltip: TooltipService,
    private modalService: NgbModal
  ) {
    this.user = this.session.GetUserDetails();
    // this.Filter.EmpMasterID = this.user.UserId;
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.Filter.EmpMasterID = this.EmployeeId;
    this.user.EmpType = this.EmpType;
    this.SelectDate('RegistrationDate', null, null);
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.Filter.IsWithdraw) {
        this.ESS_EmployeeCompOffRaiseWithdrawLoad();
      } else {
        this.ESS_EmployeeCompOffRaise_LoadLoad();
      }
    } else {
      form.submitted = true;
    }
  }

  ESS_EmployeeCompOffRaise_LoadLoad() {
    this.Filter.EmpMasterID = this.EmployeeId;
    if (moment(this.dateFromat.format(this.Filter.ToDate), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFromat.format(this.Filter.FromDate), 'DD MMM YYYY'))) {
      this.isDisabled = true;
      this.compensatoryoff.ESS_EmployeeCompOffRaise_LoadLoad({ ESS_EmployeeCompOffRaiseId: 0, EmpMasterID: this.Filter.EmpMasterID, FromDate: this.dateFromat.format(this.Filter.FromDate), ToDate: this.dateFromat.format(this.Filter.ToDate), ApprovalStatus: this.Filter.ApprovalStatus, SelectType: 2 }).subscribe({
        next: (response) => {
          if (response.Table.length > 0) {
            this.TableDatas = response.Table;
          } else {
            this.TableDatas = [];
          }

          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Filter.FromDate = this.dateFromat.parse(response.Table[0].RegistrationDate);
          this.Filter.ToDate = this.dateFromat.parse(response.Table[0].RegistrationDate);
          // this.Filter.FromDate.day = 1;
          // this.Filter.ToDate.day = parseInt(moment(response.Table[0].RegistrationDate).endOf('month').format('D'));
          this.Filter.FromDate.day = 1;
          this.Filter.FromDate.month = 1;
          this.Filter.ToDate.day = 31;
          this.Filter.ToDate.month = 12;
        }
        this.ESS_EmployeeCompOffRaise_LoadLoad();
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Clear() {
    this.TableDatas = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  ESS_EmployeeCompOffConsumeLoad() {
    this.Filter.EmpMasterID = this.EmployeeId;
    if (moment(this.dateFromat.format(this.Filter.ToDate), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFromat.format(this.Filter.FromDate), 'DD MMM YYYY'))) {
      this.isDisabled = true;
      this.compensatoryoff.ESS_EmployeeCompOffConsumeLoad({ ESS_EmployeeCompOffConsumeId: 0, EmpMasterID: this.Filter.EmpMasterID, FromDate: this.dateFromat.format(this.Filter.FromDate), ToDate: this.dateFromat.format(this.Filter.ToDate), ApprovalStatus: this.Filter.ApprovalStatus, SelectType: 4 }).subscribe({
        next: (response) => {
          if (response.Table && response.Table.length > 0) {
            this.TableDatas = response.Table;
          } else {
            this.TableDatas = [];
          }
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
  }

  async SaveEmployeeCompOffDetails(index: any) {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to withdraw?';
    modalRef.result.then(result => {
      // if (this.common.PageRight.IsView) {
      if (result) {
        this.isDisabled = true;
        this.compensatoryoff.ESS_EmployeeCompOffRaiseUpdate({ 
          SelectType: 'WITHDRAWN', 
          ESS_EmployeeCompOffRaiseId: this.TableDatas[index]['ESS_EmployeeCompOffRaiseId'],  
          // IsAdminWithdrawn: true,
          // AdminWithdrawnRequestBy: this.user.UserId
        }).subscribe({
          next: (response) => {
            if (response.Error_Code == '768') {
              const modalRef = this.modalService.open(AlertSuccessComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => {
                if (result) {
                  this.ESS_EmployeeCompOffConsumeLoad();
                }
              });
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
      // } else {
      //   this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      // }
    });
  }

  ESS_EmployeeCompOffRaiseWithdrawLoad() {
    this.Filter.EmpMasterID = this.EmployeeId;
    if (moment(this.dateFromat.format(this.Filter.ToDate), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFromat.format(this.Filter.FromDate), 'DD MMM YYYY'))) {
      this.isDisabled = true;
      this.compensatoryoff.ESS_EmployeeCompOffRaise_LoadLoad({ ESS_EmployeeCompOffRaiseId: 0, EmpMasterID: this.Filter.EmpMasterID, FromDate: this.dateFromat.format(this.Filter.FromDate), ToDate: this.dateFromat.format(this.Filter.ToDate), ApprovalStatus: this.Filter.ApprovalStatus, SelectType: 3 }).subscribe({
        next: (response) => {

          if (response.Table) {
            if (response.Table.length > 0) {
              this.TableDatas = response.Table;
            } else {
              this.TableDatas = [];
            }
          }
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
  }

  openCompoffDetails(EmployeeCompOffDetailId: any) {
    const modalRef = this.modalService.open(AdminCompoffDetailComponent, { centered: true, backdrop: 'static', size: 'xl' });
    modalRef.componentInstance.EmployeeId = this.EmployeeId;
    modalRef.componentInstance.EmployeeCompOffDetailId = EmployeeCompOffDetailId;
    modalRef.componentInstance.EmpType = this.EmpType;

    modalRef.result.then((result) => {
      if (result) {
        this.ESS_EmployeeCompOffRaise_LoadLoad();
      }
    },
      (reason) => {
        console.log('Modal dismissed:', reason);
      }
    );
  }

  compOffRequest() {
    const modalRef = this.modalService.open(AdminCompoffRequestComponent, { centered: true, backdrop: 'static', size: 'xl' });
    modalRef.componentInstance.EmployeeId = this.EmployeeId;
    modalRef.componentInstance.EmpType = this.EmpType;

    modalRef.result.then((result) => {
      if (result) {
        this.ESS_EmployeeCompOffRaise_LoadLoad();
      }
    },
      (reason) => {
        console.log('Modal dismissed:', reason);
      }
    );
  }

}
